// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UserEdit from './UserEdit';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(UserEdit);
